module.exports = __webpack_public_path__ + "img/kkp.61ee833b.svg";